import script from "./EmployeeHighlightAuditChange.vue?vue&type=script&setup=true&lang=js"
export * from "./EmployeeHighlightAuditChange.vue?vue&type=script&setup=true&lang=js"

import "./EmployeeHighlightAuditChange.vue?vue&type=style&index=0&id=146932a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-146932a4"]])

export default __exports__